import { requests } from '../../../../utils';
import {
    BASE_URL,
    BRAND_DASHBOARD_BOOKING,
    BRAND_DASHBOARD_MANAGEMENT,
    BRAND_DASHBOARD_MEASURE,
    BRAND_MANAGING_CAMPAIGN,
} from '../../../../utils/endpoints';
import { User } from '../../../../model/user/User';
import { ICampaignManagement } from './components/dto/ICampaignManagement';

export const CampaignDashboardService = {
    getManagingCampaign: (id: string): Promise<User[]> => requests.get(`${BRAND_MANAGING_CAMPAIGN}/${id}`),
    getBookingData: (id?: string) => requests.get(`${BRAND_DASHBOARD_BOOKING}/${id}`),
    getMeasureData: (id?: number) => requests.get(`${BRAND_DASHBOARD_MEASURE}/${id}`),
    getManagementData: (id?: string): Promise<ICampaignManagement> =>
        requests.get(`${BRAND_DASHBOARD_MANAGEMENT}/${id}`),
    getDiscovery: (filters?: any, queryParams: string = ''): Promise<any> =>
        requests.post(`${BASE_URL}brand/discovery?${queryParams}`, filters),
};
